module.exports = __webpack_public_path__ + "img/517-6a1497.png";